import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#050505] text-white py-12 px-4 border-t border-[#1a1a1a]" data-id="element-36">
      <div className="max-w-7xl mx-auto text-center" data-id="element-37">
        <div className="mb-6" data-id="element-38">
          <h3 className="text-xl font-bold text-white tracking-wide flex items-center justify-center gap-2" data-id="element-39">
            <span data-id="element-40">🎨</span> PROFEPACK ARTE
          </h3>
        </div>

        <div className="text-center" data-id="element-41">
          <p className="text-gray-500 text-sm mb-2" data-id="element-42">
            © 2026 Todos los derechos reservados.
          </p>
          <p className="text-gray-600 text-sm" data-id="element-43">
            Hecho con ❤️ para la comunidad educativa.
          </p>
        </div>
      </div>
    </footer>;
}